module.exports = __webpack_public_path__ + "assets/img/923734.c4a07e29.jpg";